import { cn } from "@/lib/utils";

const STYLES = {
  pending:      "bg-amber-100 text-amber-800 border-amber-200",
  approval_pending: "bg-amber-100 text-amber-800 border-amber-200",
  approved:     "bg-emerald-100 text-emerald-800 border-emerald-200",
  paid:         "bg-emerald-100 text-emerald-800 border-emerald-200",
  active:       "bg-emerald-100 text-emerald-800 border-emerald-200",
  hired:        "bg-emerald-100 text-emerald-800 border-emerald-200",
  completed:    "bg-gray-100 text-gray-700 border-gray-200",
  rejected:     "bg-red-100 text-red-800 border-red-200",
  in_progress:  "bg-blue-100 text-blue-800 border-blue-200",
  processing:   "bg-blue-100 text-blue-800 border-blue-200",
  open:         "bg-blue-100 text-blue-800 border-blue-200",
  scheduled:    "bg-blue-100 text-blue-800 border-blue-200",
  probation:    "bg-violet-100 text-violet-800 border-violet-200",
  available:    "bg-emerald-100 text-emerald-800 border-emerald-200",
  assigned:     "bg-blue-100 text-blue-800 border-blue-200",
  applied:      "bg-gray-100 text-gray-700 border-gray-200",
  screening:    "bg-blue-100 text-blue-800 border-blue-200",
  tech_interview: "bg-violet-100 text-violet-800 border-violet-200",
  hr_interview: "bg-violet-100 text-violet-800 border-violet-200",
  offer:        "bg-amber-100 text-amber-800 border-amber-200",
  documents_pending: "bg-amber-100 text-amber-800 border-amber-200",
  manager_induction: "bg-blue-100 text-blue-800 border-blue-200",
  knowledge_transfer: "bg-blue-100 text-blue-800 border-blue-200",
  present:      "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export default function StatusBadge({ status, className }) {
  if (!status) return null;
  const key = String(status).toLowerCase();
  const cls = STYLES[key] || "bg-gray-100 text-gray-700 border-gray-200";
  const label = String(status).replace(/_/g, " ");
  return (
    <span
      data-testid={`status-${key}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border capitalize",
        cls,
        className
      )}
    >
      {label}
    </span>
  );
}
